export const WS_READY = 'websocket/ready';
export const WS_RELOAD = 'websocket/reload';
export const WS_SUBSCRIBE_COMMENTS = 'websocket/subscribeComments';
export const WS_SUBSCRIBE_RESOURCE_EVENTS = 'websocket/subscribeResourceEvents';
export const WS_RECEIVED_COMMENT = 'websocket/receivedComment';
